app.controller('esEntityLookupMeedyOfferController', ['$scope', 'meedyALABModel',
    function ($scope, meedyALABModel) {

        $scope.getData = function (s) {
            if(s.length > 2) {
                var criteria = {rowsPerSheet: 10, searchPhrase: s };
                meedyALABModel.getDataPage(criteria).then(function(dataPage) {
                    $scope.items = dataPage.offers;
                    $scope.lookupInProgress = false;
                });

                $scope.lookupInProgress = true;
            } else {
                $scope.items = [];
            }
        };

        $scope.getLabel = function(item) {
            if(item) {
                return item.name;
            }
        };

    }
]);